import type { ButtonHTMLAttributes, ReactNode, Ref } from 'react';

import { cn } from '@shared/lib/cn';

import {
  type ListboxPlainItemSize,
  PLAIN_ITEM_BASE_CLASS,
  PLAIN_ITEM_HEIGHT_PX,
  PLAIN_ITEM_SELECTED_CLASS,
} from './listbox.constant';

export interface ListboxPlainItemProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'children' | 'type'
> {
  /** Figma `Label` */
  children?: ReactNode;
  /** Figma `size`: md 44(메모 날짜 · 액션포인트 분기) · sm 32(임시 저장 메모). 기본 md */
  size?: ListboxPlainItemSize;
  /** Figma `selected` — 연두 면 + primary 굵은 글자. `aria-current` 로 알린다 */
  selected?: boolean;
  ref?: Ref<HTMLButtonElement>;
}

/**
 * 옆 목록의 한 줄(체크 표시 없음, 글자 가운데, 아래 1px 선). 너비는 부모를 채운다(Figma 160).
 * Figma `_Listbox/PlainItem`.
 */
export function ListboxPlainItem({
  children,
  size = 'md',
  selected = false,
  className,
  style,
  disabled,
  ref,
  ...rest
}: ListboxPlainItemProps) {
  return (
    <button
      ref={ref}
      type="button"
      aria-current={selected || undefined}
      data-slot="listbox-plain-item"
      data-size={size}
      data-selected={selected}
      disabled={disabled}
      {...rest}
      style={{ height: PLAIN_ITEM_HEIGHT_PX[size], ...style }}
      className={cn(
        PLAIN_ITEM_BASE_CLASS,
        selected ? PLAIN_ITEM_SELECTED_CLASS.on : PLAIN_ITEM_SELECTED_CLASS.off,
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        className,
      )}
    >
      <span className="truncate">{children}</span>
    </button>
  );
}
